import Container from "@/components/base/Container";
import { stats } from "@/mocks/site";

export default function StatsBar() {
  return (
    <section className="relative z-10">
      <Container className="-mt-12 md:-mt-16">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 lg:grid-cols-4">
          {stats.map((stat) => (
            <div key={stat.id} className="flex items-center gap-3 bg-background-50 p-4 md:gap-4 md:p-6">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700 md:h-12 md:w-12">
                <i className={`${stat.icono} text-xl leading-none md:text-2xl`} aria-hidden="true"></i>
              </span>
              <div>
                <p className="text-xl font-heading font-bold text-foreground-950 md:text-2xl">
                  {stat.valor}
                </p>
                <p className="text-xs font-label text-foreground-500 md:text-sm">{stat.etiqueta}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}